import {
  createMultiStyleConfigHelpers,
  StyleThemingProps,
} from '@chakra-ui/react'
import { textStyleKeys } from '~/themes/textStyles'
import { useCustomMultiStyleConfig } from '~/utils/chakraUtils'
import { getName } from '~/utils/objectUtils'

import { phoneColorKeys } from './_colors'

const Colors = phoneColorKeys.Phone.QuickDialViewColors

const QuickDialViewParts = [
  'stack',
  'tabContainer',
  'scrollingList',
  'header',
  'headerText',
  'headerButton',
  'headerIcon',
] as const

const helpers = createMultiStyleConfigHelpers(QuickDialViewParts)
export const QuickDialViewStyle = helpers.defineMultiStyleConfig({
  baseStyle: {
    stack: {
      height: 'full',
      backgroundColor: Colors.Background,
      borderRight: '2px solid',
      borderColor: Colors.Border,
    },
    tabContainer: {
      alignItems: 'center',
      width: 'full',
      height: '4.5rem',
      paddingX: '1rem',
      gap: '0.25rem',
      borderBottom: '2px solid',
      borderColor: Colors.Border,
    },
    scrollingList: {
      flex: '1',
      width: 'full',
      height: '70%',
      paddingLeft: '0.5rem',
      paddingTop: '0.5rem',
    },
    header: {
      justifyContent: 'space-between',
      alignItems: 'center',
      width: 'full',
    },
    headerText: {
      textStyle: textStyleKeys.Body4_Bold,
    },
    headerButton: {
      boxSize: '0.75rem',
      minWidth: '0',
      bg: 'transparent',
      _hover: {
        bg: Colors.Button.Background.Hover,
      },
    },
    headerIcon: {
      boxSize: '0.75rem',
    },
  },
})

export const useQuickDialViewStyle = (props?: StyleThemingProps) => {
  return useCustomMultiStyleConfig<typeof QuickDialViewParts>(
    getName({ QuickDialViewStyle }),
    props,
  )
}
